import {Directive, ElementRef, HostListener, type OnInit, inject, input} from '@angular/core'

@Directive({
  selector: '[auto-resize-textarea]',
})
export class AutoResizeTextareaDirective implements OnInit {
  element = inject(ElementRef)

  readonly maxHeight = input<number>(undefined, {alias: 'auto-resize-textarea'})
  @HostListener('input')
  onInput(): void {
    // @TODO check
    this.adjust()
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.adjust()
    }, 500)
  }

  adjust(): void {
    const ta = this.element.nativeElement.querySelector('textarea')
    let btn: any
    if (ta) {
      if (ta.scrollHeight < this.maxHeight()) {
        ta.style.overflow = 'hidden'
      } else {
        ta.style.overflow = 'auto'
      }
      ta.style.height = 'auto'
      ta.style.height = Math.min(ta.scrollHeight, this.maxHeight()) + 'px'
      ta.parentElement.style.height = 'auto'
      ta.parentElement.style.maxHeight = this.maxHeight() + 'px'
      btn = ta.parentElement.nextSibling
      if (btn) {
        btn.hidden = !ta.value
        btn.style.marginTop =
          ta.scrollHeight > this.maxHeight() ? this.maxHeight() - btn.clientHeight - 10 + 'px'
          : ta.scrollHeight > btn.clientHeight ? ta.scrollHeight - btn.clientHeight - 10 + 'px'
          : '0px'
      }
    }
  }
}
